import ServiceWorkerInterfaceV1 from './ServiceWorkerInterfaceV1';
import { ServiceWorkerInterfaceV1Type } from '@clientos/types';

export { createNoopServiceWorkerInterface } from './NoopInterface';

let serviceWorkerInterfaceV1: ServiceWorkerInterfaceV1;

export function getServiceWorkerInterfaceV1(): ServiceWorkerInterfaceV1Type {
  return serviceWorkerInterfaceV1.getInterface();
}

export default async function initializeServiceWorkerInterfaceV1(): Promise<ServiceWorkerInterfaceV1Type> {
  if (serviceWorkerInterfaceV1) return serviceWorkerInterfaceV1.getInterface();

  serviceWorkerInterfaceV1 = new ServiceWorkerInterfaceV1();

  return serviceWorkerInterfaceV1.getInterface();
}
